import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import CountryFlagComponent from '@prisjakt/ui-country-flag';
import { CaptionText } from '@prisjakt/ui/text/variants';

export const StyledLabel = styled(CaptionText)`
  ${media.smallOnly`
      display:none;
    `}
`;

export const DesktopOnly = styled.div`
  ${media.mediumDown`display: none;`}
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex: 1 0 auto;
`;

export const Row = styled.div`
  height: 24px;
  display: flex;
  flex-direction: row;
  gap: ${layout.measurements.spacingSmall};
  align-items: center;
`;

export const StoreIcon = styled.div`
  display: flex;
  align-items: center;
  & svg {
    position: relative;
    top: 2px;
  }
  gap: 2px;
`;

export const CountryFlag = styled(CountryFlagComponent)`
  display: flex;
  flex: 1 0 auto;
  align-items: center;

  img {
    margin: 0;
  }
`;
